export default {"src":"/_next/static/media/qrl.3bf9cc6b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};